import { format } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';

const formatDateWithTimeZone = (date: Date | string | number, dateFormat: string) =>
    format(utcToZonedTime(new Date(date), 'Europe/Berlin'), dateFormat);

export default formatDateWithTimeZone;
